function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var l = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var w = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var e = function e(o, C, t) {
  return C in o ? l(o, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[C] = t;
},
    i = function i(o, C) {
  for (var t in C || (C = {})) {
    w.call(C, t) && e(o, t, C[t]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        g.call(C, t) && e(o, t, C[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as r from "react";

function p(o) {
  return r.createElement("svg", i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), r.createElement("path", {
    d: "M21.5331 6.98436C21.5483 7.2031 21.5483 7.42188 21.5483 7.64062C21.5483 14.3125 16.5991 22 7.55333 22C4.7665 22 2.17768 21.1718 0 19.7344C0.395955 19.7812 0.776628 19.7969 1.18782 19.7969C3.48728 19.7969 5.60407 19 7.29444 17.6406C5.13199 17.5938 3.31979 16.1406 2.69542 14.1406C3.00001 14.1875 3.30456 14.2187 3.62439 14.2187C4.066 14.2187 4.50766 14.1562 4.9188 14.0469C2.66499 13.5781 0.974582 11.5469 0.974582 9.09374V9.03126C1.62938 9.40627 2.39087 9.64064 3.19792 9.67185C1.87304 8.76558 1.00505 7.21873 1.00505 5.46871C1.00505 4.53123 1.24866 3.67186 1.67508 2.92185C4.09642 5.98435 7.73605 7.98432 11.8172 8.2031C11.7411 7.8281 11.6954 7.43752 11.6954 7.04688C11.6954 4.2656 13.8883 2 16.6142 2C18.0304 2 19.3096 2.60937 20.2081 3.59375C21.3198 3.37501 22.3858 2.95311 23.33 2.375C22.9644 3.5469 22.1878 4.53128 21.1675 5.15624C22.1574 5.04691 23.1168 4.7656 24 4.37502C23.3301 5.37498 22.4924 6.26557 21.5331 6.98436V6.98436Z",
    fill: "black"
  }));
}

export { p as ReactComponent };